const plans = {
  "plans.hero.badge": "Simple & Transparent Pricing",
  "plans.hero.title.line1": "Choose Your",
  "plans.hero.title.line2": "Perfect Plan",
  "plans.hero.subtitle": "Scale your AI automation with the right plan. All plans include a 30-day cycle with full access to core features.",
  "plans.name.basic": "Basic",
  "plans.name.pro": "Pro",
  "plans.name.enterprise": "Enterprise",
  "plans.description.basic": "Perfect for individuals starting out with AI automation",
  "plans.description.pro": "Ideal for growing businesses and teams",
  "plans.description.enterprise": "For large-scale operations with maximum power",
  "plans.badge.popular": "Most Popular",
  "plans.price.perDays": "days",
  "plans.getStarted": "Get Started with",
  "plans.compare.badge": "Compare Plans",
  "plans.compare.title": "Full Feature Breakdown",
  "plans.compare.subtitle": "See exactly what you get with each plan and find the best fit for your needs.",
  "plans.compare.feature": "Feature",
  "plans.compare.basic": "Basic",
  "plans.compare.pro": "Pro",
  "plans.compare.enterprise": "Enterprise",
  "plans.feature.messages": "Messages / month",
  "plans.feature.tokens": "Tokens / month",
  "plans.feature.sessions": "WhatsApp Sessions",
  "plans.feature.automation": "Automation Rules",
  "plans.feature.analytics": "Analytics History",
  "plans.feature.bulk": "Bulk Messaging",
  "plans.feature.csv": "Product Import",
  "plans.feature.api": "API Access",
  "plans.feature.support": "Support",
  "plans.feature.textResponse": "Text Response",
  "plans.feature.voiceResponse": "Voice Message Response",
  "plans.feature.imageResponse": "Image Response",
  "plans.feature.documentResponse": "Document Response",
  "plans.value.unlimited": "Unlimited",
  "plans.value.basic": "Basic",
  "plans.value.advanced": "Advanced",
  "plans.value.fullSuite": "Full Suite",
  "plans.value.days7": "7 days",
  "plans.value.days30": "30 days",
  "plans.value.unlimitedDays": "Unlimited",
  "plans.value.email": "Email",
  "plans.value.priority": "Priority",
  "plans.value.dedicated": "Dedicated",
  "plans.faq.badge": "Got Questions?",
  "plans.faq.title": "Frequently Asked Questions",
  "plans.faq.q1": "Can I switch plans anytime?",
  "plans.faq.a1": "Absolutely. You can upgrade or downgrade your plan at any point during your billing cycle. Changes take effect immediately.",
  "plans.faq.q2": "What happens when I reach my message or token limit?",
  "plans.faq.a2": "You will receive a notification when you approach your limit. Your service continues but additional usage is paused until the next cycle or plan upgrade.",
  "plans.faq.q3": "Do unused messages roll over to the next month?",
  "plans.faq.a3": "No, each 30-day cycle starts fresh with the full allocation. Use it or lose it — so make the most of every cycle.",
  "plans.faq.q4": "Is there a free trial available?",
  "plans.faq.a4": "We do not offer a free trial at the moment, but the Basic plan is designed to be an affordable entry point with enough power to get started.",
  "plans.finalCta.title": "Ready to Get Started?",
  "plans.finalCta.subtitle": "Pick the plan that fits your needs and start automating your WhatsApp communication today. No login required — just pay and go.",
  "plans.finalCta.button": "Choose Your Plan",
  "plans.payment.title": "Complete Payment",
  "plans.payment.total": "Total",
  "plans.payment.pay": "Pay Now",
  "plans.payment.cancel": "Cancel",
  "plans.payment.youSelected": "You selected",
  "plans.payment.plan": "Plan",
  "plans.payment.perDays": "/ {{duration}} days",
  "plans.payment.firstName": "First Name",
  "plans.payment.firstNamePlaceholder": "Ali",
  "plans.payment.lastName": "Last Name",
  "plans.payment.lastNamePlaceholder": "Hassan",
  "plans.payment.email": "Email Address",
  "plans.payment.emailPlaceholder": "ali@example.com",
  "plans.payment.phone": "Phone Number",
  "plans.payment.processing": "Processing...",
  "plans.payment.payButton": "Pay {{price}}",
  "plans.payment.digitsLeft": "{{count}} left",
  "plans.payment.enterMoreDigits": "Enter {{count}} more digit",
  "plans.payment.enterMoreDigitsPlural": "Enter {{count}} more digits",
  "plans.payment.err.firstNameRequired": "First name is required",
  "plans.payment.err.lastNameRequired": "Last name is required",
  "plans.payment.err.emailRequired": "Email is required",
  "plans.payment.err.emailInvalid": "Enter a valid email address",
  "plans.payment.err.phoneRequired": "Phone number is required",
  "plans.payment.err.phoneDigitsOnly": "Phone must contain only digits",
  "plans.payment.err.phoneLength": "Must be exactly {{digits}} digits",
  "plans.messages": "Messages",
  "plans.tokens": "Tokens",
};

export default plans;